// 学生向け画面の配色とフォント（DESIGN.md のトークン）。

export const STUDENT_COLORS = {
  bg: "#FAFAF7",
  surface: "#FFFFFF",
  ink: "#18181B",
  muted: "#71717A",
  line: "#E4E4E7",
  paper: "#FDFCF7",
  paperLine: "#ECE5D4",
  strip: "#FAF7EF",
  cyan: "#0E7490",
  cyanSoft: "#ECFEFF",
  purple: "#7C3AED",
  green: "#15803D",
  greenSoft: "#DCFCE7",
  orangeFrom: "#FF8A3D",
  orangeTo: "#FF6B1A",
  rose: "#BE123C",
  roseSoft: "#FFF1F2",
};

export const STUDENT_FONT =
  '"Hiragino Sans", "Noto Sans JP", "Yu Gothic", "Meiryo", system-ui, sans-serif';
